import React, { useState, useEffect, useRef } from "react";
import './ExperiencedetailsofProfile.css';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const ExperiencedetailsofProfile = ({ onPrevious }) => {
  const fromDateRef = useRef(null);
  const toDateRef = useRef(null);
  const [experienceDetails, setExperienceDetails] = useState([{
    companyName: '',
    skillSet: '',
    fromDate: '',
    toDate: '',
    yearOfExperience: '',
    designation: '',
    resume: null
  }]);
  const [formErrors, setFormErrors] = useState({});
  useEffect(() => {
    const saved = localStorage.getItem("experienceData");
    if (saved) {
      setExperienceDetails(JSON.parse(saved));
    }
  }, []);


  const handleChange = (index, fieldName, value) => {
    const updated = [...experienceDetails];
    updated[index][fieldName] = value;
    setExperienceDetails(updated);
    localStorage.setItem("experienceData", JSON.stringify(updated)); // Save after every change
  };



  const handleFileChange = (e, fieldName) => {
    const file = e.target.files[0];
    if (file) {
      const updatedForms = [...experienceDetails];
      updatedForms[0][fieldName] = {
        name: file.name,
        size: file.size,
        type: file.type,
      }; // Save file metadata instead of the full file object
      setExperienceDetails(updatedForms);
      // Store file metadata (instead of file object) in localStorage
      localStorage.setItem("experienceData", JSON.stringify(updatedForms));
      // Optionally store the file in a global object (window._uploadedFiles)
      if (!window._uploadedFiles) {
        window._uploadedFiles = {};
      }
      window._uploadedFiles[fieldName] = file; // Store the full file here, if needed
    }
  };

  // const isLastExperienceEntryValid = () => {
  //   const lastIndex = experienceDetails.length - 1;
  //   const entry = experienceDetails[lastIndex];
  //   const uploadedResume = window._uploadedFiles?.[`resume[${lastIndex}]`];

  //   return (
  //     entry.companyName?.trim() &&
  //     entry.designation&&
  //     entry.skillSet?.trim() &&
  //     entry.fromDate &&
  //     entry.toDate &&
  //     entry.yearOfExperience &&
  //     uploadedResume instanceof File
  //   );
  // };

  const handleAddExperience = () => {
    setExperienceDetails(prev => [
      ...prev,
      {
        companyName: '',
        skillSet: '',
        fromDate: '',
        toDate: '',
        yearOfExperience: '',
        designation: '',
        resume: null
      }
    ]);
  };
  const calculateYearOfExperience = (index) => {
    const fromDate = new Date(experienceDetails[index].fromDate);
    const toDate = new Date(experienceDetails[index].toDate);
    const diffInTime = toDate.getTime() - fromDate.getTime();
    const diffInYears = diffInTime / (1000 * 3600 * 24 * 365);
    const updatedData = [...experienceDetails];
    updatedData[index].yearOfExperience = diffInYears.toFixed(1);
    setExperienceDetails(updatedData);
    localStorage.setItem("experienceData", JSON.stringify(updatedData)); // ✅ save it
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = JSON.parse(localStorage.getItem('formData')) || {};
    const addressformData = JSON.parse(localStorage.getItem('addressData')) || {};

    const educationDetails = JSON.parse(localStorage.getItem('educationData')) || [];


    const selectedJobId = localStorage.getItem('selectedJobId') || '';

    try {
      const formDataToSend = new FormData();

      // Personal Info
      formDataToSend.append('jobId', selectedJobId);
      formDataToSend.append('surName', formData.surName);
      formDataToSend.append('Name', formData.name);
      formDataToSend.append('guardianName', formData.guardianName);
      formDataToSend.append('relationship', formData.relationship);
      formDataToSend.append('gender', formData.gender);
      const dob = new Date(formData.bDay);
      formDataToSend.append(
        'bDay',
        formData.bDay && !isNaN(dob) ? dob.toISOString().split('T')[0] : ''
      );

      formDataToSend.append('mobileNumber', formData.mobileNumber ? String(formData.mobileNumber) : '');

      formDataToSend.append('email', formData.email);
      formDataToSend.append('maritalStatus', formData.maritalStatus);
      formDataToSend.append('nationality', formData.nationality);
      formDataToSend.append('religion', formData.religion);
      formDataToSend.append('physicallyHandicapped', formData.handicapped);
      formDataToSend.append('hearingProblem', formData.hearing);
      formDataToSend.append('visualProblem', formData.visual);

      if (window._uploadedFiles?.employeePhoto) {
        formDataToSend.append('employeePhoto', window._uploadedFiles.employeePhoto);
      }

      // Address Info
      formDataToSend.append('doorNo', addressformData.doorNo);
      formDataToSend.append('street', addressformData.street);
      formDataToSend.append('landmark', addressformData.landmark);
      formDataToSend.append('panchayat', addressformData.panchayat);
      formDataToSend.append('block', addressformData.block);
      formDataToSend.append('district', addressformData.district);
      formDataToSend.append('state', addressformData.state);
      formDataToSend.append('pinCode', addressformData.pincode);
      formDataToSend.append('country', addressformData.country);

      // Education Info
      educationDetails.forEach((entry, index) => {
        formDataToSend.append(`education[${index}].qualifications`, entry.qualifications);
        formDataToSend.append(`education[${index}].specialization`, entry.specialization);
        formDataToSend.append(`education[${index}].institutionName`, entry.institutionName);
        formDataToSend.append(`education[${index}].board`, entry.board);
        formDataToSend.append(`education[${index}].cgpa`, entry.cgpa);
        formDataToSend.append(`education[${index}].yearOfPassing`, entry.yearOfPassing);

        const certFile = window._uploadedFiles[`uploadCertificate_${index}`];
        if (certFile) {
          formDataToSend.append(`uploadCertificate[${index}]`, certFile);  // ✅ Real file only
        }
      });


      // Experience Info
      experienceDetails.forEach((exp, index) => {
        formDataToSend.append(`experience[${index}].companyName`, exp.companyName || '');
        formDataToSend.append(`experience[${index}].designation`, exp.designation || '');
        formDataToSend.append(`experience[${index}].skillSet`, exp.skillSet || '');
        formDataToSend.append(`experience[${index}].fromDate`, exp.fromDate || '');
        formDataToSend.append(`experience[${index}].toDate`, exp.toDate || '');
        formDataToSend.append(`experience[${index}].yearOfExperience`, exp.yearOfExperience || '');
      });

      if (window._uploadedFiles?.resume) {
        formDataToSend.append('resume', window._uploadedFiles.resume);
      }

      // POST request
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/personal-info`, {
        method: 'POST',
        body: formDataToSend,
      });

      if (response.ok) {
        const message = await response.text(); // Use `.text()` for plain text responses
        alert('Form submitted successfully!');
        console.log('Response:', message); // Logs: "Person ID 1234 created successfully"
        localStorage.removeItem('selectedJobId')
        localStorage.removeItem('formData');
        localStorage.removeItem('addressData');
        localStorage.removeItem('educationData');
        localStorage.removeItem("qualifications")
        localStorage.removeItem('experienceData');

        setExperienceDetails([{
          companyName: '',
          skillSet: '',
          fromDate: '',
          toDate: '',
          yearOfExperience: '',
          designation: '',
          resume: ""
        }]);

      } else {
        const errorText = await response.text(); // Handle error as plain text too
        console.error('Submission failed:', errorText);
        alert('Submission failed. Please check the console for details.');
      }

    } catch (error) {
      console.error('Error submitting form:', error);
      alert('An unexpected error occurred.');
    }
  };
  const lastEntry = experienceDetails[experienceDetails.length - 1];
  const isAddDisabled = !lastEntry.resume;

  return (
    <React.Fragment>
      <div className="experiencedetailsofprofile-container">
        <div className="experiencedetailsofprofile-box">
          <form onSubmit={handleSubmit}>
            <h2 className="experiencedetailsofprofile-heading">Experience Details</h2>
            {experienceDetails.map((entry, index) => (
              <div key={index} className="experiencedetailsofprofile-form">
                <div className={`did-floating-label-content ${formErrors.surName ? 'did-error-input' : ''}`}>
                  <input type="text" placeholder=" " className="did-floating-input" value={entry.companyName}
                    onChange={(e) => {
                      const value = e.target.value; if (/^[a-zA-Z\s]*$/.test(value)) {
                        handleChange(index, 'companyName', value);
                      }
                    }} />
                  <label className="did-floating-label"><span className="label-text">Company&nbsp;Name</span></label>
                </div>
                <div className={`did-floating-label-content ${formErrors.name ? 'did-error-input' : ''}`}>
                  <input type="text" placeholder=" " className="did-floating-input" value={entry.designation} // ✅ Bind value to state
                    onChange={(e) => {
                      const value = e.target.value; if (/^[a-zA-Z\s]*$/.test(value)) {
                        handleChange(index, 'designation', value);
                      }
                    }} />
                  <label className="did-floating-label"><span className="label-text">Designation</span></label>
                </div>
                <div className={`did-floating-label-content ${formErrors.name ? 'did-error-input' : ''}`}>
                  <input type="text" className="did-floating-input" placeholder=" " value={entry.skillSet} onChange={(e) => handleChange(index, 'skillSet', e.target.value)} />
                  <label className="did-floating-label"><span className="label-text">Skill&nbsp;Set</span></label>
                </div>
                <div className="experiencedetailsofprofile-input-containers-file">
                  <label>Upload Resume</label>
                  <input type="file" name="resume" onChange={(e) => handleFileChange(e, 'resume')} />
                </div>
                <div className={`did-floating-label-content ${formErrors.name ? 'did-error-input' : ''} ${entry.fromDate ? 'filled' : ''}`}>
                  <DatePicker
                    selected={entry.fromDate ? new Date(entry.fromDate) : null}
                    onChange={(date) => {
                      const formatted = date ? date.toISOString().split('T')[0] : '';
                      handleChange(index, 'fromDate', formatted);
                      calculateYearOfExperience(index);
                    }}
                    dateFormat="dd-MM-yyyy"
                    placeholderText=""
                    className="did-floating-input"
                  />
                  <label className="did-floating-label"><span className="label-text">From&nbsp;Date</span></label>
                </div>
                <div className={`did-floating-label-content ${formErrors.name ? 'did-error-input' : ''} ${entry.toDate ? 'filled' : ''}`}>
                  <DatePicker
                    selected={entry.toDate ? new Date(entry.toDate) : null}
                    onChange={(date) => {
                      const formatted = date ? date.toISOString().split('T')[0] : '';
                      handleChange(index, 'toDate', formatted);
                      calculateYearOfExperience(index);
                    }}
                    dateFormat="dd-MM-yyyy"
                    placeholderText=""
                    className="did-floating-input"
                  />
                  <label className="did-floating-label"><span className="label-text">To&nbsp;Date</span></label>
                </div>
                <div className={`did-floating-label-content ${formErrors.name ? 'did-error-input' : ''}`}>
                  <input className="did-floating-input" type="text" name="yearOfExperience" placeholder="Experience" value={entry.yearOfExperience} readOnly />
                  <label className="did-floating-label"><span className="label-text">Year&nbsp;of&nbsp;Experience</span></label>
                </div>
              </div>
            ))}
            <div className="experiencedetails-add-btn-container">
              <button type="button" className="experiencedetails-table-btn" onClick={handleAddExperience} disabled={isAddDisabled}>+</button>
            </div>
            <div className="experiencedetailsofprofile-btns-div">
              <button type="button" className="experiencedetailsofprofile-btn" onClick={onPrevious}>Previous</button>
              <button type="submit" className="experiencedetailsofprofile-btn-next" disabled={isAddDisabled} >Submit</button>
            </div>
          </form>
        </div>
      </div>
    </React.Fragment>
  )
}
export default ExperiencedetailsofProfile;